import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { ContentType, SortDirection, CursorMode } from './Enums'
/**
* Class ContentListRequestQuery
*  Query params for operation "ContentList"
*/
export class ContentListRequestQuery extends ActiveModel {

  /**
  * ['Filter.Type']
  * Фильтр по типу контента (новости, страницы, инструкции)<br>  */
  @ActiveField()
  ['Filter.Type']?: ContentType


/**
  * ['Filter.Tag']
  * Фильтр по тегу (точное совпадение)<br>
  */
  @ActiveField()
  ['Filter.Tag']?: string


/**
  * Query
  * Поисковый запрос<br>
  */
  @ActiveField()
  Query?: string


  /**
  * Limit
  * Кол-во элементов в результате. <br><br>Если значение меньше 1, то вернуть все элементы<br>  */
  @ActiveField()
  Limit?: number


/**
  * SortField
  * Поле для сортировки<br>
  */
  @ActiveField()
  SortField?: string


  /**
  * SortDirection
  * Направление сортировки<br>  */
  @ActiveField()
  SortDirection?: SortDirection


  /**
  * CursorMode
  * Режим курсора. Если значение указано, то необходимо<br>указывать Web.Core.Pagination.SortOptions.CursorField и Web.Core.Pagination.SortOptions.CursorId  */
  @ActiveField()
  CursorMode?: CursorMode


/**
  * CursorField
  * Значение Web.Core.Pagination.SortOptions.SortField первого/последнего элемента<br>(в зависимости от курсора Web.Core.Pagination.SortOptions.CursorMode),<br>полученное в рамках ответа на предыдущий курсорный запрос<br>
  */
  @ActiveField()
  CursorField?: string


/**
  * CursorId
  * Значение уникального ключа (чаще всего, но не обязательно, это id) первого/последнего элемента<br>(в зависимости от курсора Web.Core.Pagination.SortOptions.CursorMode),<br>полученное в рамках ответа на предыдущий курсорный запрос<br>
  */
  @ActiveField()
  CursorId?: string
}
